import { render, staticRenderFns } from "./messagePush.vue?vue&type=template&id=60fada2e&scoped=true&"
import script from "./messagePush.vue?vue&type=script&lang=js&"
export * from "./messagePush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fada2e",
  null
  
)

export default component.exports